import React, { Component } from "react";
import axios from 'axios';
import moment from 'moment';

import Chart from "react-apexcharts";
import { lastMounths, serverUrl, headerRequest, noStatistic} from '../../../lib/funApp/general'

import { Card } from "react-bootstrap";

export default class IncomesExpensesLine extends Component {
  constructor(props) {
    super(props);
    this.lastMounths = lastMounths(7).reverse()
    this.state = {
        series: [],
        options: {
            chart: {
                height: 350,
                type: 'area',
                toolbar: {
                    show: true,
                    offsetX: 0,
                    offsetY: 0,
                    tools: {
                        download: true,
                        selection: false,
                        zoom: false,
                        zoomin: false,
                        zoomout: false,
                        pan: false,
                        reset: false | '<img src="/static/icons/reset.png" width="20">',
                        customIcons: []
                    },
                },
            },
            dataLabels: {
                enabled: false
            },
            legend:{
                position: "top"
            },
            stroke: {
                curve: 'smooth'
            },
            xaxis: {
                type: 'text',
                categories: this.lastMounths.map((item,i)=>(
                    item.labelReduce
                ))
            },
            colors: ['#007CFF','#FF2D00'],
        },
      };
    }

    componentDidMount() {
        const targetUrl = serverUrl
        + '/src/records-recdesp?dtstart=' + moment().startOf('month').subtract(6, "month").format('YYYY-MM-DD')
        + '&dtend='+ moment().endOf('month').format('YYYY-MM-DD')
        + '&noStatistic=' + noStatistic
        + '&tp=recdesp'

        axios.get(targetUrl, {"headers" : headerRequest})
        .then(res => {
            if(res.status === 200){

                let testeR = []
                let testeD = []

                this.lastMounths.map((item,i)=>(
                   res.data.items.map((item2,i2)=>(
                       item.number === item2._id.month
                       && item.year === item2._id.year ?
                            item2._id.type === 'R' ?
                                testeR.push({month: item2._id.month, year: item2._id.year, total: item2.total})
                            :   testeD.push({month: item2._id.month, year: item2._id.year, total: (item2.total*-1)})
                        : false
                   ))

                ))

                let serieR = []
                let newSerieR = []
                this.lastMounths.map((item,i)=>(
                    serieR.push(testeR.filter(obj => {
                        return item.number === obj.month
                                && item.year === obj.year
                      }))
                ))
                serieR.map((item,i)=>(
                    item[0] !== undefined ?
                    newSerieR.push(item[0].total.toFixed(2))
                    :newSerieR.push(0)
                ))

                let serieD = []
                let newSerieD = []
                this.lastMounths.map((item,i)=>(
                    serieD.push(testeD.filter(obj => {
                        return item.number === obj.month
                                && item.year === obj.year
                      }))
                ))
                serieD.map((item,i)=>(
                    item[0] !== undefined ?
                    newSerieD.push((item[0].total*-1).toFixed(2))
                    :newSerieD.push(0)
                ))

                this.setState({
                    series: [{
                        name: 'Receitas',
                        data: newSerieR
                    }, {
                        name: 'Despesas',
                        data: newSerieD
                    }],
                })
            }
        })
    }

    render() {
        return (
            <Card>
                <Card.Body>
                    <div className="mixed-chart">
                        <Chart
                            options={this.state.options}
                            series={this.state.series}
                            type="area"
                        />
                    </div>
                </Card.Body>
            </Card>
        );
    }
}